<template>
  <div>
    <mdb-card>
      <mdb-card-title class="pl-3 pt-3">
        <div class="clearfix">
          <div class="float-left  sub-title">
            <mdb-icon far icon="comment-alt" /> {{student}} {{seq}}차 정기상담 작성
          </div>
          <div class="float-right title pr-3">
            <save-btn-sm class="mr-1" @click="$emit('save')">저장</save-btn-sm>
            <delete-btn-sm @click="$emit('delete')">삭제</delete-btn-sm>
          </div>
        </div>
      </mdb-card-title>
      <mdb-card-body>
        <div class="clearfix  underline mb-3">
          <div class="float-left title">
            <mdb-icon icon="user-edit" /> 상담자:  {{counsel.counseler.name}}
          </div>
          <div class="float-right clock">
            <mdb-icon icon="clock"/> 상담일: {{$strDate(counsel.regDate)}}
          </div>
        </div>
        <mdb-input type="textarea" class="mt-1" :rows="5" v-model="counsel.content"/>
        <div class="mt-4 underline title"><mdb-icon icon="check" /> 조치사항</div>
        <mdb-input type="textarea" class="mt-1" :rows="3" v-model="counsel.action"/>
      </mdb-card-body>
    </mdb-card>
    <!-- <div class="title">특이사항</div>
    <mdb-input type="textarea" class="mt-1" :rows="3" v-model="counsel.etc"/> -->
  </div>
</template>
<script>
import { mdbCard, mdbCardTitle, mdbCardBody, mdbInput } from 'mdbvue';
import RegularCounsel from '@/models/RegularCounsel';
export default {
  name: 'Counsel',
  components: { mdbCard, mdbCardTitle, mdbCardBody, mdbInput },
  props: ['counsel', 'counseler', 'seq', 'student']
}
</script>
